module.exports = __webpack_public_path__ + "static/media/MenuHappyHour.af1631d4.pdf";